import { ScrollSpy } from "./scroll-spy";
import "./lookup-form";
import { zoomCity, zoomCountry, zoomCompany } from "./map";
import "./main.css";

/**
 * ScrollSpy initialization
 */

let scrollSpy;
let scrollable = document.getElementById("sidebar-scrollable");
window.onload = function() {
  scrollSpy = new ScrollSpy("#sidebar-menu", {
    scrollable,
    sectionSelector: "section",
    targetSelector: ".sidebar-tab-button",
    offset: 100,
    activeClass: "active",
    onActive: () => {
      const url = new URL(window.location.href);
      const currentSectionId = scrollSpy.getCurrentSection().id;

      if (currentSectionId === "geolocation") {
        url.hash = "";
        zoomCountry();
      } else if (currentSectionId === "city") {
        url.hash = "";
        zoomCity();
      } else {
        const isOwner = currentSectionId === "owner";
        url.hash = isOwner ? "company" : currentSectionId;
        zoomCompany(isOwner);
      }

      history.replaceState({}, "", url);
    }
  });

  scrollSpy.onScroll();

  scrollable.addEventListener("scroll", () => {
    scrollSpy.onScroll();
  });
};

const tabButtons = document.querySelectorAll(".sidebar-tab-button");
tabButtons.forEach(item => {
  item.addEventListener("click", e => {
    e.preventDefault();
    const target = document.getElementById(item.getAttribute("href").slice(1));
    scrollable.scrollTo({
      top: target.offsetTop,
      behavior: "smooth"
    });
  });
});
